export default class FiltroConsultarOrcamento{
    constructor () {
        this.NumeroSolicitacao = undefined;
        this.CodigoProduto = undefined;
        this.NomeProduto = undefined;
        this.LinhaProduto = undefined;
        this.Status = 20;
        this.PeriodoDeBaixaInicio = undefined;
        this.PeriodoDeBaixaFim = undefined;
        this.PeriodoDeEmissaoInicio = undefined;
        this.PeriodoDeEmissaoFim = undefined;
        this.QuantidadeDeDiasPendentes = undefined;
        this.EmpresasIds = undefined;
        this.ClientesIds = undefined;
        this.ClienteId = undefined;
        this.RepresentanteId = undefined;
        this.EmpresaId = null;
        this.Ordenacao = undefined;
        this.NomeProdutoNovo = undefined;
        this.ProdutoId = undefined;

    }
}